<?xml version="1.0" encoding="UTF-8"?>
<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 63.1 (92452) - https://sketch.com -->
    <title>6840CCDE-E9F1-4065-8B51-8F08C00BF745@2x</title>
    <desc>Created with Sketch.</desc>
    <g id="Specs" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Buttons-&amp;-Inputs" transform="translate(-166.000000, -4213.000000)" fill="#6C6F80">
            <g id="Inputs" transform="translate(120.000000, 1878.000000)">
                <g id="Form-Elements/x/label/36-42/_default-Copy-2" transform="translate(0.000000, 2334.000000)">
                    <g id="Label">
                        <g id="18/notification/info-outline" transform="translate(45.000000, 0.000000)">
                            <path d="M8,13 L10,13 L10,8 L8,8 L8,13 Z M9,1 C4.584,1 1,4.584 1,9 C1,13.416 4.584,17 9,17 C13.416,17 17,13.416 17,9 C17,4.584 13.416,1 9,1 Z M9,16 C5.14125,16 2,12.85875 2,9 C2,5.14125 5.14125,2 9,2 C12.85875,2 16,5.14125 16,9 C16,12.85875 12.85875,16 9,16 Z M8,7 L10,7 L10,5 L8,5 L8,7 Z" id="icon"></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>